import { TRUCK_ACTION } from "./string";

export const URL_COMMON = {
	LOCATION_SEARCH: "/api/common/location-search/",
	PROVINCE: "/api/common/province/",
	CONFIG: "/api/common/config/",
	MANNUAL: "/api/common/manual/"
}

export const URL_AUTH = {
  	API_TOKEN_AUTH: "/api/users/api-token-auth/",
  	MEMBER_TOKEN_AUTH: "/api/users/member-token-auth/",
  	API_LIFF_TOKEN_AUTH: "/api/users/liff-token-auth/",
	CHECK_LIFF_AUTH: "/api/users/checking-liff-auth/",
  	CHANGE_PASSWORD: "/api/users/change-password/",
  	SIGN_OUT: "/api/users/sign-out/",
};

export const URL_USER = {
	USER: "/api/users/user/",
	GROUP: "/api/users/group/",
};

export const URL_TRUCK = {
	TRUCK_TRANSACTION: "/api/truck/truck-transaction/",
	TRUCK_TRANSACTION_WEIGHT: "/api/truck/truck-transaction-weight-log/",
	POND_AVAILABLE_COUNT: "/api/truck/truck-transaction/pond-available-count/",
	RAW_LATEX_PRICE_LIST: "/api/truck/raw-latex-price/",
	CONDITIONS_OF_PURCHASE: "/api/lab/cheimal-warning-range/",
	TRUCK_TRANSFER_TRANSACTION: "/api/tank/tank-transfer-transaction/",
	VEHICLE_TYPE : "/api/truck/vehicle-type/",
	VEHICLE : "/api/truck/vehicle/",
	PAYMENT_TRANSACTION: '/api/truck/payment-transaction/',
	PAYMENT_TRANSACTION_GENERATE_DOCUMENT_NO: '/api/truck/payment-transaction/generate-document-no/',
	TRUCK_TRANSACTION_DAILY_SUMMARY: "/api/truck/truck-transaction/daily-summary/",
	CHEMICAL_TRANSFER: "/api/truck/raw-latex-supplier-chemical-transfer-transaction/",
	CHEMICAL_TRANSFER_DETAIL: "/api/truck/raw-latex-supplier-chemical-transfer-detail/",
	TRUCK_TRANSACTION_STATUS : '/api/truck/truck-transaction/status/',
};

export const URL_LAB = {
	LAB_ORDER: "/api/lab/lab-order/",
	LAB_INPUT: "/api/lab/lab-input/",
	LAB_ORDER_INPUT_ORDER: "/api/lab/lab-order/input-order/",
}

export const URL_EMPLOYEE = {
	EMPLOYEE : "/api/employee/employee/",
	VERIFY_EMPLOYEE: "/api/employee/verify-employee/",
}

export const URL_CUSTOMER = {
	RAW_LATEX_SUPPLIER : "/api/customer/raw-latex-supplier/"
}

export const URL_POND = {
	POND : "/api/pond/pond/",
	POND_TRANSACTION : "/api/pond/pond-transaction/",
	POND_TRUCK_TRANSCATION : "/api/pond/pond-truck-transaction/",
	POND_TRANSACTION_WEIGHT_LOG :"/api/pond/pond-transaction-weight-log/", // ?pond_transaction=<uuid>/</uuid>
	POND_TRANSACTION_STATE_LOG :"/api/pond/pond-transaction-state-log/", // ?pond_transaction=<uuid>/</uuid>
	POND_PAYMENT_TRANSACTION : "/api/truck/payment-transaction/",
}

export const URL_SALE = {
	SALE_ORDER : "/api/sale/sale-order/",
	PRODUCE_ORDER : "/api/sale/produce-order/",
	SALE_BUYER : "/api/customer/buyer/",
	SALE_PACKING : "/api/sale/packing/",
	SALE_PRODUCT : "/api/product/product/",
	SALE_DELIVER : "/api/sale/deliver/",
	SALE_SHIPPING : "/api/sale/shipping/",
	SALE_LOCATION : "/api/sale/location/",
	DELIVERY_ORDER : "/api/sale/delivery-order/",
	LOAD_TANK_TRANSACTION : "/api/sale/load-tank-transaction/",
	DELIVERY_ADDRESS : "/api/customer/delivery-address/",
	SKIM_SALE_ORDER : '/api/sale/skim-sale-order/',
	SKIM_PRODUCE_ORDER : '/api/sale/skim-produce-order/',
	SKIM_DELIVERY_ORDER : '/api/sale/skim-delivery-order/',
	LOAD_SKIM_STOCK : '/api/sale/load-skim-stock/'
}

export const URL_CHEMICAL = {
	PURE_CHEMICAL : "/api/chemical/pure-chemical/",
	QUALITY_CHEMICAL : "/api/chemical/quality-chemical/",
	QUALITY_CHEMICAL_TANK : "/api/chemical/quality-chemical-tank/",
	QUALITY_CHEMICAL_TRANSACTION : "/api/chemical/quality-chemical-transaction/",
	QUALITY_CHEMICAL_TANK_TRANSACTION : "/api/chemical/quality-chemical-tank-transaction/",
	PURE_CHEMICAL_TRANSACTION : "/api/chemical/pure-chemical-transaction/",
	CHEMICAL_MIX_TRANSACTION : "/api/chemical/chemical-mix-transaction/",
	METER : "/api/chemical/chemical-tank-meter/",
	SKIM_CHEMICAL_WITHDRAW : "/api/chemical/skim-chemical-transaction-withdraw-log/",
	CHANGE_QUALITY_TANK_LOG: "/api/chemical/change-quality-tank-log/",
}

export const URL_SETTING = {
	POND : "/api/pond/pond/",
	TANK : "/api/tank/tank/",
	PRODUCT : "/api/product/product/",
	SELLER_CHEMICAL : "/api/customer/chemical-supplier/",
	SELLER_CCT_LATEX : "/api/customer/concentrate-latex-supplier/",
	SELLER_RAW_LATEX : "/api/customer/raw-latex-supplier/",
	BUYER : "/api/customer/buyer/",
	LOCATION : "/api/sale/location/",
	SHIPPING : "/api/sale/shipping/",
	DELIVER : "/api/sale/deliver/",
	PACKING : "/api/sale/packing/",
	SHIPPING_ADDRESS : "/api/customer/delivery-address/",
	CONFIG_FACTORY : "/api/factories/config-factory/",
	BANK_ACCOUNT : "/api/factories/bank-account/",
}
 
export const URL_TANK = {
	TANK : '/api/tank/tank/',
	TANK_TRANSACTION : '/api/tank/tank-transaction/',
	TANK_TRANSACTION_WEIGHT_LOG: '/api/tank/tank-transaction-weight-log/',
	TANK_TRANSACTION_STATUS_LOG: '/api/tank/tank-transaction-state-log/',
	TANK_TRANSFER_TRANSACTION :'/api/tank/tank-transfer-transaction/',
	TANK_POND_TRANSACTION : '/api/tank/tank-pond-transaction/',
	IMPORT_CONCENTRATE_STOCK: '/api/tank/imported-concentrate-latex-stock/',
	IMPORT_CONCENTRATE_STOCK_WEIGHT_LOG: '/api/tank/imported-concentrate-latex-stock-weight-log',
	IMPORT_CONCENTRATE_STOCK_TRANSACTION: '/api/tank/tank-imported-concentrate-latex-stock-transaction/'
}

export const URL_PRODUCT = {
	PRODUCT : '/api/product/product/'
}

export const URL_SKIM = {
	SKIM_POND : '/api/skim/skim-pond/',
	SKIM_TRANSACTION : '/api/skim/skim-transaction/',
	SKIM_TRANSACTION_WEIGHT_LOG : '/api/skim/skim-transaction-weight-log/',
	SKIM_STOCK : '/api/skim/skim-stock/',
	SKIM_STOCK_LOG : '/api/skim/skim-stock-log/',
	SKIM_CHEMICAL : '/api/chemical/skim-chemical/',
	SKIM_CHEMICAL_TRANSACTION : '/api/chemical/skim-chemical-transaction/',
	SKIM_INPUT_CHEMICAL_TRANSACTION : '/api/skim/skim-input-chemical-transaction/',
	SKIM_TRACK : '/api/skim/skim-track/',
	SKIM_PRODUCE_TRANSACTION : '/api/skim/skim-produce-transaction/'
}

export const URL_REPORT = {
	LAB_REQUEST_ORDER : '/api/report/lab-request-order/',
	LAB_INPUT_ORDER : '/api/report/lab-input-order/',
	LAB_INPUT_ORDER_ALL : '/api/report/lab-input-order-all/',
	DELIVERY_BILL: '/api/report/delivery-bill/',
	DELIVERY_BILL_PAPER_FORM: '/api/report/delivery-bill-paper-form/',
	FINALIZED_DELIVERY_ORDER_BILL: '/api/report/finalized-delivery-order-bill/',
	RAW_LATEX_IMORT: '/api/report/raw-latex-import/',
	RAW_LATEX_IMORT_CUSTOMER: '/api/report/raw-latex-import-customer/',
	RAW_LATEX_RECEIPT: '/api/report/raw-latex-receipt/',
	LOAD_ORDER: '/api/report/load-order/',
	SKIM_DISPATCH: '/api/report/skim-dispatch/',
	// pond summary report
	POND_SUMMARY: '/api/report/pond-summary/',
	POND_SUMMARY_REPORT: '/api/report/pond-summary-report/',
	// tank summary report
	TANK_SUMMARY: '/api/report/tank-summary/',
	CONCENTRATE_LATEX_SUMMARY: '/api/report/concentrate-latex-stock/',
	// pure chemical summary report
	PURE_CHEMICAL_DETAIL : '/api/report/pure-chemical-detail/',
	// quality chemical summary report
	QUALITY_CHEMICAL_SUMMARY: '/api/report/quality-chemical-summary/',
	QUALITY_CHEMICAL_DETAIL: '/api/report/quality-chemical-detail/',
	// skim summary report
	SKIM_SUMMARY: '/api/report/skim-summary/',
	SKIM_SUMMARY_REPORT: '/api/report/skim-summary-report/',
	// daily raw latex report
	DAILY_RAW_LATEX_REPORT_S: '/api/report/daily-raw-latex-report-s/',
	DAILY_RAW_LATEX_REPORT_D: '/api/report/daily-raw-latex-report-d/',
	ACCOUNT_INCOME: '/api/report/account-income/',
	TRUCK_TRANSACTION_DRC_REPORT: '/api/report/truck-transaction-drc-report/',
	DAILY_RAW_LATEX: '/api/report/daily-raw-latex/',

	RAW_LATEX_IMPORT_CUSTOMER_MONTHLY: '/api/report/raw-latex-import-customer-monthly/',
	DRC_MONTHLY: "/api/report/drc-monthly/",
	POND_LATEX_LAB_ORDER: '/api/report/pond-latex-lab-order/',
	CONCENTRATE_LATEX_DELIVERY: '/api/report/concentrate-latex-delivery/',
	DELIVERY_SKIM_MONTHLY: '/api/report/delivery-skim-monthly/',
	REMAINING_TANK_WEIGHT: '/api/report/remaining-tank-weight/',
	CONCENTRATE_LATEX_SALE_ORDER: '/api/report/concentrate-latex-sale-order/',
	PRODUCE_ORDER: '/api/report/produce-order/',
	DELIVERY_CONCENTRATE_LATEX_MONTHLY: '/api/report/delivery-concentrate-latex-monthly/',
	SKIM_SALE_ORDER : '/api/report/skim-sale-order/',
	PURE_CHEMICAL_SUMMARY: '/api/report/pure-chemical-summary/',
	PRODUCE_CONCENTRATED_LATEX_DAILY: '/api/report/produce-concentrated-latex-daily/',
	TRUCK_TYPE_RAW_LATEX_MONTHLY: '/api/report/truck-type-raw-latex-monthly/',
	RAW_LATEX_CHEMICAL_AMOUNT: '/api/report/raw-latex-chemical-amount/',
	SKIM_PRODUCE_TRANSACTION: '/api/report/skim-produce-transaction/',
	SKIM_CHEMICAL_USE: '/api/report/skim-chemical-use/',
	SKIM_PRODUCE: '/api/report/skim-produce/',
	SKIM_PRODUCE_MONTHLY: '/api/report/skim-produce-monthly/',
	CHEMICAL_USAGE: '/api/report/chemical-usage/',
	TRUCK_REJECT_ENTRY: '/api/report/truck-reject-entry-report/',
	CERTIFICATE_OF_ANALYSIS: '/api/report/certificate-of-analysis/'
}
